import { Dialog, TextV2 } from '@insights-ltd/design-library/components';
import { Trans, useTranslation } from 'react-i18next';
import CustomerExperienceLink from 'components/CustomerExperienceLink';

export type MergeLearnersErrorDialogProps = {
  onRetry: () => void;
  onCancel: () => void;
  isLoading: boolean;
};

export const MERGE_ERROR_CONTENT_KEY =
  'ui.event-management.merge-learner.combine-learners.error.content';

const MergeLearnersErrorDialog = ({
  onRetry,
  onCancel,
  isLoading,
}: MergeLearnersErrorDialogProps) => {
  const { t } = useTranslation();

  const handleClose = () => {
    if (!isLoading) {
      onCancel();
    }
  };

  return (
    <Dialog
      open
      onClose={handleClose}
      onSubmit={onRetry}
      isLoading={isLoading}
      title={t(
        'ui.event-management.merge-learner.combine-learners.error.title',
      )}
      primaryButtonText={t(
        'ui.event-management.merge-learner.combine-learners.error.retry-button',
      )}
      secondaryButtonText={t(
        'ui.event-management.merge-learner.combine-learners.error.cancel-button',
      )}
      content={
        <TextV2 component="p">
          <Trans
            i18nKey={MERGE_ERROR_CONTENT_KEY}
            values={{
              contactTeamName: t('ui.common.customer-experience-team'),
            }}
            components={{
              email: (
                <CustomerExperienceLink
                  id="merge-error-link-customer-exp"
                  fontSize="inherit"
                />
              ),
            }}
          />
        </TextV2>
      }
    />
  );
};

export default MergeLearnersErrorDialog;
